import React, { useContext, useEffect, useState } from 'react';
import { Context_UI } from '../../Contexts/Context_UI';
import { useAuth } from '../../Contexts/AuthContext';
import { Templates_Get_All, Templates_Initialize, Templates_Update } from '../../api/API_Templates'
import UI_Button from '../ERUMAUI/UI_Button';
import UI_Input_Text from '../ERUMAUI/UI_Input_Text';
import UI_Card from '../ERUMAUI/UI_Card';
import UI_Icon from '../ERUMAUI/UI_Icons';
import UI_Divider from '../ERUMAUI/UI_Divider';
import Icon_Edit from '../../Assets/Icons/Icon_Edit.png';
import { useTemplating } from '../../Contexts/Context_Templating';
import { useScheduleManagement } from '../../Contexts/Context_ScheduleManagement';
import { useAccounts } from '../../Contexts/Context_Accounts';
import { useLocation } from 'react-router-dom';



export default function Panel_Center_Left() {
    const { Account, Loading } = useAuth();
    const { User, User_Permission, User_Role, User_Change_Password } = useAccounts();
    const UI = useContext(Context_UI);
    const Location = useLocation();

    

    const Permission_Item = ({ Text, State }) => {
        return (
            <div className='User_Permissions_Item' State={State ? "Positive" : "Negative"}>
                {State ?
                    <UI_Icon Name="Check" />
                    :
                    <UI_Icon Name="Cross" />
                }
                <p className='User_Permissions_Item_Text'>
                    {Text}
                </p>
            </div>
        );
    }

    useEffect(() => {
        if (Location.pathname === "/user/edit") {
            User_Change_Password();
            // UI.Subwindows_Open("Window_User_Edit");
        }
    }, [Location.pathname])

    if (Loading || !User || !User_Permission) {
        return null;
    }
    return (
        <>
            <h1 className='General_Title'>
                {User?.Name_Compounded}
            </h1>
            <p className='General_Paragraph'>
                {User.Email}
            </p>
            <div className='User_Role'>
                <UI_Icon Name="User" />
                <p className='User_Permissions_Item_Text'>
                    {User_Role}
                </p>
            </div>
            <UI_Divider Text="" />
            <h2 className='General_Title'>
                Your permissions
            </h2>
            <div className='General_Split' Split="3">
                <div>
                    <UI_Divider Text="Interactive map" />
                    <div className='User_Permissions'>
                        <Permission_Item
                            Text="View the interactive map"
                            State={User_Permission.InteractiveMap.View}
                        />
                        <Permission_Item
                            Text="Edit the interactive map's contents"
                            State={User_Permission.InteractiveMap.Edit}
                        />
                    </div>
                </div>
                <div>
                    <UI_Divider Text="Schedules and reservations" />
                    <div className='User_Permissions'>
                        <Permission_Item
                            Text="View details of reservations"
                            State={User_Permission.Schedules.View}
                        />
                        <Permission_Item
                            Text="Make reservations"
                            State={User_Permission.Reservation.Create}
                        />
                        <Permission_Item
                            Text="Reschedule, relocate, and edit reservations"
                            State={User_Permission.Reservation.Edit}
                        />
                        <Permission_Item
                            Text="Approve reservations as OSA"
                            State={User_Permission.Reservation.Approve.Initial}
                        />
                        <Permission_Item
                            Text="Approve reservations as GSU"
                            State={User_Permission.Reservation.Approve.Final}
                        />
                    </div>
                </div>
                <div>
                    <UI_Divider Text="Reporting" />
                    <div className='User_Permissions'>
                        <Permission_Item
                            Text="Generate schedule timetable documents"
                            State={User_Permission.Report.ScheduleTimetable}
                        />
                        <Permission_Item
                            Text="Generate room utilization documents"
                            State={User_Permission.Report.RoomUtilization}
                        />
                        <Permission_Item
                            Text="Generate map overview documents"
                            State={User_Permission.Report.MapOverview}
                        />
                        <Permission_Item
                            Text="Generate account information documents"
                            State={User_Permission.Report.AccountList}
                        />
                        <Permission_Item
                            Text="Generate activity log documents"
                            State={User_Permission.Report.ActivityLog}
                        />
                    </div>
                </div>
            </div>
            <UI_Divider />
            <h2 className='General_Title'>
                Edit details
            </h2>
            <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
                <UI_Card
                    Type="Home"
                    Shape="Square"
                    Icon={Icon_Edit}
                    Text="Change password"
                    Destination='user/edit'
                />

            </div>
        </>
    );
}
